export default __webpack_public_path__ + "static/media/Group (5).ad8fe0b6.svg";